import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

class Tabs extends React.Component {
  constructor() {
    super()

    this.state = {
      activeTabId: null,
      activeTab: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTabId) {
      const tab = nextProps.tabs.find((tab) => tab.id === nextProps.activeTabId)

      this.setState({
        activeTabId: nextProps.activeTabId,
        activeTab: tab.contents,
      })
    }
  }

  componentDidMount() {
    if (this.props.activeTabId) {
      const tab = this.props.tabs.find((tab) => tab.id === this.props.activeTabId)

      this.setState({
        activeTabId: this.props.activeTabId,
        activeTab: tab.contents,
      })
    } else {
      this.setState({
        activeTabId: this.props.tabs[0].id,
        activeTab: this.props.tabs[0].contents,
      })
    }
  }

  onTabClick(id) {
    const activeTab = this.props.tabs.filter(tab => tab.id === id)

    this.setState({
      activeTabId: id,
      activeTab: activeTab[0].contents,
    })
  }

  render() {
    const tabs = (
      <ul className="nav-tabs nav-tabs--bordered-small">
        {this.props.tabs.map((tab) => {
          return (
            <li key={`tab-head-${tab.id}`} className={tab.id === this.state.activeTabId ? 'is-active' : ''}>
              <a data-name={tab.id} onClick={() => { this.onTabClick(tab.id) }}>
                {tab.title}
                {tab.counter > 0 && <span className="u-ml10 indicator indicator--square">{tab.counter}</span>}
              </a>
            </li>
          )
        })}
      </ul>
    )

    return (
      <Fragment>
        {this.props.useContainer ? (
          <div className="container-fixed">
            {tabs}
          </div>
        ) : (
          tabs
        )}

        <div className="tabs-content">
          <div className="tab-pane">
            {this.props.useContainer ? (
              <div className="container-fixed">
                {this.state.activeTab}
              </div>
            ) : (
              this.state.activeTab
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    id: PropTypes.string.isRequired,
    contents: PropTypes.node.isRequired,
    counter: PropTypes.number,
  })).isRequired,
  activeTabId: PropTypes.string,
  useContainer: PropTypes.bool,
}

Tabs.defaultProps = {
  activeTabId: null,
  counter: 0,
  useContainer: false,
}

export default Tabs
